import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { PortalProvider } from '@gorhom/portal';
import { theme } from '@sweetgreen/garnish';

import { useResetDietaryRestrictionsOnLogout } from '@order/components';
import { useCustomerTelemetry } from '@order/Customer';
import {
  useAppTrackingTransparency,
  useCreateLoyaltyProfile,
  useFetchUserCart,
  useNetworkSubscription,
  usePushNotifications,
} from '@order/hooks';
import { useTrackLastInteractedStore } from '@order/LastInteractedStore';

import { useFacebookPixel } from './integrations/facebook-pixel';
import { useEmptyPageTabNavigationFix } from './navigation';
import { AppNavigation } from './navigation/AppNavigation';

// ────────────────────────────────────────────────────────────────────────────────

export const AppContent = memo(() => {
  useCustomerTelemetry();
  useFetchUserCart();
  useNetworkSubscription();
  usePushNotifications();
  useEmptyPageTabNavigationFix();
  useResetDietaryRestrictionsOnLogout();
  useFacebookPixel();
  useTrackLastInteractedStore();
  useAppTrackingTransparency();
  useCreateLoyaltyProfile();

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.appContainer}>
      <PortalProvider>
        <AppNavigation />
      </PortalProvider>
    </View>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  appContainer: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: theme.colors.OATMEAL,
  },
});
